<template>
  <div class="powerbi-report">
    <div id="reportContainer" style="height:600px;"></div>
  </div>
</template>

<script>
import * as pbi from 'powerbi-client';

export default {
  name: 'Juridico',

  data() {
    return {
      reportContainer: null
    }
  },

  mounted() {
    this.initializePowerBIReport();
  },

  methods: {
    initializePowerBIReport() {
      // Configurações do Power BI Embedded
      const reportContainer = document.getElementById('reportContainer');
      const embedConfig = {
        type: 'report',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: 'YOUR_EMBED_TOKEN',
        embedUrl: 'YOUR_EMBED_URL',
        id: 'YOUR_REPORT_ID',
        permissions: pbi.models.Permissions.All,
        settings: {
          panes: {
            filters: {
              visible: false
            }
          }
        }
      };

      // Inicializa o Power BI Report
      const powerbi = new pbi.Service(
        window['powerbi-client'].services,
        window['powerbi-client'].models
      );
      powerbi.embed(reportContainer, embedConfig);
    }
  }
}
</script>
